import { DtoBase } from "../DtoBase";
import { List } from "DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { TenantDto } from 'UvExplorerServer.Dtos.TS/Utils/TenantDto';
import { SuperServerDto } from 'UvExplorerServer.Dtos.TS/LinkedServers/SuperServerDto';
import { SubServerDto } from 'UvExplorerServer.Dtos.TS/LinkedServers/SubServerDto';


export class GetLinkedServersResultDto extends DtoBase {

	public Tenant: TenantDto;
	public SuperServer: SuperServerDto;
	public SubServers: List<SubServerDto>;

	constructor() {
		super();

		this.Tenant = null;
		this.SuperServer = null;
		this.SubServers = new List<SubServerDto>();
	}

	public get HasTenant(): boolean {
		return !!this.Tenant;
	}

	public get HasSuperServer(): boolean {
		return !!this.SuperServer;
	}

	public get HasSubServers(): boolean {
		return (!!this.SubServers && this.SubServers.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_linked_servers_result = {};
		obj = obj.get_linked_servers_result;

		super.Write(obj, context);

		if (this.HasTenant) {
			this.Tenant.Write(obj, context);
		}

		if (this.HasSuperServer) {
			this.SuperServer.Write(obj, context);
		}

		if (this.HasSubServers) {
			obj.sub_servers = [];
			ObjSerUtils.WriteObjSerCollection(obj.sub_servers, this.SubServers, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_linked_servers_result)
			throw new Error();
		obj = obj.get_linked_servers_result;

		super.Read(obj, context);

		if (obj.tenant !== undefined) {
			this.Tenant = new TenantDto();
			this.Tenant.Read(obj, context);
		}

		if (obj.super_server !== undefined) {
			this.SuperServer = new SuperServerDto();
			this.SuperServer.Read(obj, context);
		}

		if (obj.sub_servers !== undefined) {
			this.SubServers.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.sub_servers, this.SubServers,
				(value: any) => new SubServerDto(), context);
		}
	}

}